import React, { useEffect } from "react";
import CcButton from "../../CoilConfigurator/components/CcButton";

const TERMS: [string, string][] = [
  [
    "CWC",
    "Concrete Weight Coating — a heavy concrete layer added over the anti-corrosion coating for negative buoyancy; leaves a cutback window the frame/coil must pass through.",
  ],
  [
    "CMPP",
    "Chamfer Multi-Pass PP — a multi-pass field-joint infill technique that requires a double-hinge autocoat rig.",
  ],
  ["FBE", "Fusion Bonded Epoxy — the base anti-corrosion coating layer."],
  [
    "HSS",
    "A larger induction-coil bore variant used over thicker (typically 3-layer PP) field-joint coatings than FBE-only joints.",
  ],
  [
    "PP Toe",
    "The tapered lead-in of the factory-applied polypropylene coating, measured by length and thickness.",
  ],
  [
    "Kite",
    "The carriage assembly that centers and drives the blast head around the pipe; its type depends on head size and clearance.",
  ],
  [
    "Step-Down",
    "A reduced-diameter section on an induction coil, needed when the coating build-up exceeds the coil’s standard clearance.",
  ],
  [
    "Bottom End",
    "The lower body section of the induction coil frame; its version sets overall length and CWC compatibility.",
  ],
];

interface GlossaryModalProps {
  open: boolean;
  onClose: () => void;
}

const GlossaryModal = ({ open, onClose }: GlossaryModalProps) => {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="dialog-scrim"
      role="presentation"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="dialog-card op-glossary-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="op-glossary-title"
      >
        <div className="dialog-header">
          <h2 className="dialog-title" id="op-glossary-title">
            Glossary
          </h2>
          <CcButton variant="icon" aria-label="Close glossary" onClick={onClose}>
            ✕
          </CcButton>
        </div>
        <div className="dialog-body op-glossary-modal__body">
          {TERMS.map(([term, definition]) => (
            <div className="op-glossary-row" key={term}>
              <span className="op-glossary-row__term">{term}</span>
              <span className="op-glossary-row__def">{definition}</span>
            </div>
          ))}
        </div>
        <div className="dialog-footer">
          <CcButton variant="primary" onClick={onClose}>
            Close
          </CcButton>
        </div>
      </div>
    </div>
  );
};

export default GlossaryModal;
